export const TID = {
  // Login
  loginPhone: "login-phone-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  loginError: "login-error",

  // Layout
  sidebar: "app-sidebar",
  navDashboard: "nav-dashboard",
  navStudents: "nav-students",
  navAttendance: "nav-attendance",
  navCoaches: "nav-coaches",
  navProfile: "nav-profile",
  logoutButton: "logout-button",

  // Dashboard
  kpiTotal: "kpi-total",
  kpiActive: "kpi-active",
  kpiExpiring: "kpi-expiring",
  kpiExpired: "kpi-expired",
  addStudentHeader: "dashboard-add-student",
  activityFeed: "coach-activity-feed",
  activityRow: (id) => `activity-row-${id}`,
  activityEmpty: "activity-empty",
  reminderCard: (id) => `reminder-card-${id}`,
  reminderWhatsApp: (id) => `reminder-whatsapp-${id}`,
  feeReminderCard: (id) => `fee-reminder-card-${id}`,
  feeReminderWhatsApp: (id) => `fee-reminder-whatsapp-${id}`,

  // Students
  studentsList: "students-list",
  studentRow: (id) => `student-row-${id}`,
  studentsFabAdd: "students-fab-add",
  studentSearch: "student-search",
  filterActive: "filter-active",
  filterExpiring: "filter-expiring",
  filterExpired: "filter-expired",
  filterAll: "filter-all",

  // Student New / Edit
  studentNameInput: "student-name-input",
  studentAgeInput: "student-age-input",
  studentPhoneInput: "student-phone-input",
  studentStartInput: "student-start-date",
  studentEndInput: "student-end-date",
  studentAmountInput: "student-amount-input",
  studentPendingInput: "student-pending-input",
  studentDueInput: "student-due-input",
  studentCoachSelect: "student-coach-select",
  studentSaveBtn: "student-save-btn",

  // Student Detail
  studentRenewBtn: "student-renew-btn",
  studentRenewDate: "student-renew-date",
  studentRenewAmount: "student-renew-amount",
  studentRenewSubmit: "student-renew-submit",
  studentSendMsg: "student-send-message",
  studentSendReceipt: "student-send-receipt",
  studentEditLink: "student-edit-link",
  studentDeleteBtn: "student-delete-btn",

  // Coaches
  coachesFabAdd: "coaches-fab-add",
  coachRow: (id) => `coach-row-${id}`,
  coachEditBtn: (id) => `coach-edit-${id}`,
  coachDeleteBtn: (id) => `coach-delete-${id}`,
  coachNameInput: "coach-name-input",
  coachPhoneInput: "coach-phone-input",
  coachPasswordInput: "coach-password-input",
  coachSaveBtn: "coach-save-btn",

  // Attendance
  attendanceDate: "attendance-date",
  attendanceMarkAll: "attendance-mark-all",
  attendanceSubmit: "attendance-submit",
  attendanceCheckbox: (id) => `attendance-check-${id}`,
  coachMarkOwn: "coach-mark-own",
  coachReviewApprove: (id) => `coach-review-approve-${id}`,
  coachReviewReject: (id) => `coach-review-reject-${id}`,

  // Profile
  settingsToggle: "settings-coaches-can-add",

  // Pending approvals (admin dashboard)
  pendingList: "pending-approvals-list",
  pendingApprove: (id) => `pending-approve-${id}`,
  pendingReject: (id) => `pending-reject-${id}`,
  pendingReview: (id) => `pending-review-${id}`,
  reviewApproveBtn: "review-approve-btn",
  reviewRejectBtn: "review-reject-btn",

  // Pending coach attendance (admin dashboard)
  pendingCoachAttendanceList: "pending-coach-attendance-list",
  pendingCoachAttendanceDownload: "pending-coach-attendance-download-excel",
};
